import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './Button.module.css'
import styleNames from '../../utils/styleNames'
import classNames from 'classnames'

export class Button extends Component {
  render () {
    const {
      small,
      medium,
      large,
      secondary,
      onClick,
      text,
      marginRight,
      marginLeft,
      autoFocus,
      loading
    } = this.props

    const buttonStyles = classNames('button', {
      small: small,
      medium: medium,
      large: large,
      secondary: secondary,
      'margin-right': marginRight,
      'margin-left': marginLeft,
      loading: loading
    })

    const disabled = this.props.disabled ? 'disabled' : ''

    return (
      <button 
        autoFocus={autoFocus}
        disabled={disabled}
        onClick={onClick} 
        className={styleNames(styles, buttonStyles)}>
        <span>{text}</span>
      </button>
    )
  }
}

Button.propTypes = {
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  large: PropTypes.bool,
  loading: PropTypes.bool,
  marginLeft: PropTypes.bool,
  marginRight: PropTypes.bool,
  medium: PropTypes.bool,
  onClick: PropTypes.func,
  secondary: PropTypes.bool,
  size: PropTypes.string,
  small: PropTypes.bool,
  text: PropTypes.string.isRequired
}

export default Button
